module.exports = __webpack_public_path__ + "img/fif-measurement.63923689.png";